import { createSlice } from '@reduxjs/toolkit';

export type OptionType = {
  isActive: boolean;
  answerOption: string;
  isCorrectAnswer: boolean;
  correctAnswer: string;
  answerPlaceHolder: string;
  answerFieldType: string;
};

export type QuestionData = {
  questionTitle: string;
  questionInstructions: string;
  question: string;
  questionDescription: string;
  explanation: string;
  questionType: string;
  domain: string;
  company: string[];
  moduleId: string;
  image: Record<string, any>;
  correctAnswer: string;
  options: OptionType[];
  more?: Record<string, any>;
};

const addQuestionSlice = createSlice({
  name: 'addQuestion',
  initialState: {
    questionData: {
      questionTitle: '',
      questionInstructions: '',
      question: '',
      questionDescription: '',
      explanation: '',
      questionType: 'Single/ MCQ / SAQ',
      domain: '',
      company: ['', ''],
      moduleId: '',
      image: {},
      correctAnswer: '',
      options: [
        {
          isActive: true,
          answerOption: '',
          isCorrectAnswer: true,
          correctAnswer: '',
          answerPlaceHolder: '',
          answerFieldType: ''
        }
      ],
      more: {}
    }
  },
  reducers: {
    setQuestionData: (state, action) => {
      const { key, value } = action.payload;
      state.questionData = { ...state.questionData, [key]: value };
    }
  }
});

export const { setQuestionData } = addQuestionSlice.actions;

export default addQuestionSlice.reducer;
